/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React, { useState } from "react";
import {
  useHistory,
} from "react-router-dom";
import Login from "../components/ForgotPassword";
import { login } from "../../../api/UserServices";

const ForgotPasswordContainer = () => {
  const history = useHistory();
  const [loginData, setLoginData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [showPasssword, setShowPassword] = useState(false);

  const handleSubmitLoginDetails = (e) => {
    e.preventDefault();
    setSubmitting(true);
    login(loginData).then((response) => {
      setSubmitting(false);
      if (response && response.success && response.data) {
        history.push({ pathname: "/customers" });
      } else {
        setError("Incorrect username or password");
      }
    });
  };

  /**
 * This method is used to handle change IN text
 *
 * @param {String} key
 * @param {Object} e
 */
  const handleChange = (key, e) => {
    setError("");
    setLoginData({ ...loginData, [key]: e.target.value });
  };

  const toggleShowPassword = () => setShowPassword(!showPasssword);

  return (
    <>
      <Login
        handleSubmitLoginDetails={handleSubmitLoginDetails}
        loginData={loginData}
        error={error}
        submitting={submitting}
        handleChange={handleChange}
        toggleShowPassword={toggleShowPassword}
        showPasssword={showPasssword}
      />
    </>
  );
};
export default ForgotPasswordContainer;
